
function Loading(props) {
  return <div className="loading">
    <p>Cargando</p>
    {props.text && <p>{props.text}</p>}
  </div>;
}

export default Loading;
